// Signup level fundIt with Tiers

const publicView6 = {
  success: true,
  signupList: {
    ID: 11,
    title: "Mocked Test Event",
    description: "",
    backgroundColor: "#016099",
    backgroundColorScheme: ["#016099", "#13426B"],
    media: {
      // image
      imageUrl: "https://placehold.co/600x360",
      photoID: 8265775,
      type: "image",
      // video
      // videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
      // type: "video",
    },
    createdBy: { userID: 2, name: "Super Admin", date: 1688999862 },
    options: {
      allowMultipleItemSignups: 1,
      shared: 1,
      public: 1,
      expireDate: 0,
      sendReminderAt: 0,
      showConfetti: 1,
    },
    signupListVerbs: {
      ID: 1,
      title: "an Event",
      entity: "spot",
      entityPlural: "spots",
      actionName: "Sign Up",
      actionAsATitle: "Sign up for",
      actionNamePresentTense: "signing up",
      cancelName: "Cancel",
      howManyQuestion: "How many people are coming?",
      confirmOne: "you're in!",
      confirmMultiple: "you're in for # people!",
      cancelOne: "We've cancelled your spot for this event.",
      cancelMultiple: "We've cancelled your spots for this event.",
      status: 1,
    },
    signupListStatusID: 1,
    scheduledReminderSent: [],
    manualRemindersSent: [],
    signupListTypeID: 1,
    fundIt: {
      blockAutomaticRefunds: true,
      isSuggestedDonation: false,
      hasSignupCost: true,
      fund: {
        ID: 3,
        name: "Galaxy Fund",
        confirmationMessage: null,
        signupPaymentsCollected: false,
      },
      cost: {
        costType: "PerSignup",
        amounts: [
          {
            numberOfSlots: 2,
            amount: 1000,
            id: 1,
          },
          {
            numberOfSlots: null,
            amount: 10000,
            id: 2,
          },
        ],
      },
    },
    blockAutomaticRefunds: true,
    signupItems: [
      {
        ID: 28,
        title: "Nose Bleeds",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 4,
        maxSingleUserSlots: 4,
        orderNumber: 0,
        showRespondentsCount: true,
        fundIt: {
          hasSignupCost: true,
          cost: {
            costType: "PerItem",
            amounts: [
              {
                numberOfSlots: 2,
                amount: 10000,
                id: 10,
              },
              {
                numberOfSlots: null,
                amount: 20000,
                id: 20,
              },
            ],
          },
        },
        extendedFields: [
          {
            type: "picker",
            icon: "info-circle fas far",
            multiSelect: true,
            options: [
              {
                ID: 10,
                title: "First Option",
              },
              {
                ID: 11,
                title: "Second Option",
              },
              {
                ID: 12,
                title: "Third Option",
              },
            ],
            title: "multiSelect Test",
            fieldID: 41,
            inputIsRequired: false,
            entityType: "user",
          },
          {
            type: "date",
            icon: "info-circle fas far",
            includeYear: false,
            title: "NoYear",
            fieldID: 87,
            inputIsRequired: false,
            entityType: "user",
          },
          {
            type: "address",
            icon: "map-marker-alt fas",
            defaultCountryID: 1,
            allowChangeCountry: true,
            title: "Address",
            fieldID: 5,
            inputIsRequired: false,
            entityType: "user",
          },
        ],
        fieldsOnItem: [
          {
            title: "multiSelect Test",
            icon: "info-circle fas far",
            configuration: {
              behaviorOptions: {
                allowMultiple: true,
              },
              responseOptions: {
                optionsType: "responseOptionList",
                responseOptionList: [
                  {
                    optionListValueID: 10,
                    optionListValue: "First Option",
                  },
                  {
                    optionListValueID: 11,
                    optionListValue: "Second Option",
                  },
                  {
                    optionListValueID: 12,
                    optionListValue: "Third Option",
                  },
                ],
              },
            },
            visibility: "private",
            isCustomField: true,
            networkFieldID: 41,
            createdByID: 64,
            fieldTypeID: 5,
            fieldTypeInstanceID: 31,
            fieldResponseEditPermissionID: 1,
            fieldResponseViewPermissionID: 1,
            fieldResponseOptionListID: 3,
            fieldResponseEntity: "user",
            blockSharing: false,
            required: false,
            fromProfile: true,
          },
          {
            title: "NoYear",
            icon: "info-circle fas far",
            configuration: {
              subfields: {
                year: {
                  isVisible: "0",
                },
              },
            },
            visibility: "private",
            isCustomField: true,
            networkFieldID: 87,
            createdByID: 2,
            fieldTypeID: 2,
            fieldTypeInstanceID: 56,
            fieldResponseEditPermissionID: 1,
            fieldResponseViewPermissionID: 1,
            fieldResponseOptionListID: null,
            fieldResponseEntity: "user",
            blockSharing: false,
            required: false,
            fromProfile: true,
          },
          {
            title: "Address",
            icon: "map-marker-alt fas",
            configuration: {
              type: "address",
              subfields: {
                addr1: {
                  isVisible: true,
                },
                addr2: {
                  isVisible: false,
                },
                city: {
                  isVisible: true,
                },
                state: {
                  isVisible: true,
                },
                zip: {
                  isVisible: true,
                },
                country: {
                  isVisible: true,
                },
              },
              responseOptions: {
                default: {
                  city: "",
                  state: "",
                  country: "US",
                },
              },
            },
            visibility: "default",
            networkFieldID: 5,
            createdByID: 2,
            fieldTypeID: 4,
            fieldTypeInstanceID: 5,
            fieldResponseEditPermissionID: 1,
            fieldResponseViewPermissionID: 1,
            fieldResponseOptionListID: null,
            fieldResponseEntity: "user",
            blockSharing: false,
            required: false,
            fromProfile: true,
          },
        ],
      },
      {
        ID: 29,
        title: "Club Level",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 3,
        maxSingleUserSlots: 4,
        orderNumber: 1,
        showRespondentsCount: false,
        fundIt: {
          hasSignupCost: true,
          cost: {
            costType: "PerItem",
            amounts: [
              {
                numberOfSlots: null,
                amount: 50000,
              },
            ],
          },
        },
        fundName: "Signup - All New Test Event",
      },
      {
        ID: 30,
        title: "50 Yard Line",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 2,
        maxSingleUserSlots: 4,
        orderNumber: 2,
        hasSignupCost: false,
        amount: null,
        // showRespondentsCount: true,
        fundIt: {
          hasSignupCost: true,
          cost: {
            costType: "PerSlot",
            amounts: [
              {
                numberOfSlots: null,
                amount: 75000,
              },
            ],
          },
        },
        fundName: null,
      },
    ],
  },
  notes: [],
  network: {
    ID: 2,
    name: "Test Net",
    hasSignupPayments: true,
  },
  user: {
    ID: 2,
    firstName: "Super",
    lastName: "Admin",
    email: {
      ID: 2,
      type: "email",
      status: "active",
      verified: true,
      address: "superadmin@testnet.com",
    },
    isAdminOfAnyGroup: true,
    canSignupHouseholdMembers: false,
    household: [],
    householdID: 1,
  },
  userSignupItems: {
    30: {
      count: 2,
      respondents: [
        {
          name: "Tink Wing",
          isAdditionalName: true,
          userID: null,
          additionalNameID: 74,
          paymentStatus: null,
        },
        {
          name: "Super Admin",
          isAdditionalName: false,
          userID: 2,
          additionalNameID: 75,
          paymentStatus: null,
        },
      ],
    },
  },
  allSignupListTypes: [
    {
      ID: 1,
      title: "an Event",
    },
    {
      ID: 2,
      title: "Seats",
    },
    {
      ID: 4,
      title: "a Poll",
    },
    {
      ID: 5,
      title: "Items",
    },
    {
      ID: 7,
      title: "Volunteers",
    },
  ],
  isApp: false,
  userID: 2,
};

export default publicView6;
